import { Injectable, LOCALE_ID } from '@angular/core';
import { AreaItemPack } from '../models/area-item-pack';
import { BookingService } from './booking.service';
import { Observable, Subscriber, of } from 'rxjs';
import { AreaItem } from '../models/area-item';
import { TimeRestriction } from '../models/time-restriction';
import { BookingSlot } from '../models/booking-slot';
import { DayOfWeek } from '../models/day-of-week';
import { DecimalPipe } from '@angular/common';
import { Product } from '../../order/models/product';
import { BookingInMemoryAreaItemGenerator, } from './booking-in-memory.area-item.generator';
import { BookingInMemoryBookingSlotGenerator, BookingSlotGeneratorParams, } from './booking-in-memory.booking-slot-generator';
import { GroupEventOrder } from '../../order/models/group-event-order';
import { ContactField } from '../../contact/models/contact-field';
import { EventAreaItemSlot } from '../models/event-area-item-slot';

@Injectable()
export class BookingInMemoryService implements BookingService {
  private _bookingInMemoryAreaItemGenerator = new BookingInMemoryAreaItemGenerator();

  private _timeRestrictions = new Map<number, TimeRestriction[]>([
    [1, [
      new TimeRestriction(DayOfWeek.Sunday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Monday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Tuesday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Wednesday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Thurstday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Friday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Saturday, 9.00, 23.00),
    ]],
    [2, [
      new TimeRestriction(DayOfWeek.Sunday, 9.00, 10.00),
      new TimeRestriction(DayOfWeek.Saturday, 9.00, 10.00),
    ]],
    [3, [
      new TimeRestriction(DayOfWeek.Friday, 21.00, 23.00),
    ]],
    [4, [
      new TimeRestriction(DayOfWeek.Sunday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Monday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Tuesday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Wednesday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Thurstday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Friday, 9.00, 23.00),
      new TimeRestriction(DayOfWeek.Saturday, 9.00, 23.00),
    ]]
  ]);


  private _eventBookingSlotParams = new Map<number, BookingSlotGeneratorParams>(
    [
      [200, new BookingSlotGeneratorParams(12, 2.5, 0.5, true)],
      [201, new BookingSlotGeneratorParams(7, 2.5, 0.5, true)],
      [202, new BookingSlotGeneratorParams(12, 2.5, 0.5, true)],
      [203, new BookingSlotGeneratorParams(12, 2.5, 0.5, true)],
      [204, new BookingSlotGeneratorParams(12, 2.5, 0.5, true)],
    ]);

  private _productCapacities = new Map<number, number>([
    [1, 102],
    [2, 102],
    [3, 102],
    [4, 102],

    [5, 102],
    [6, 102],
    [7, 102],
    [8, 102],
    [9, 102],
    [10, 102],
    [11, 102],
    [12, 102],
  ]);

  private _eventBookingSlotsGenerator = new BookingInMemoryBookingSlotGenerator(new BookingSlotGeneratorParams(100, 2.4, 0.5, true));
  private _bookingSlotsGenerator = new BookingInMemoryBookingSlotGenerator();

  getAreaItems(areaItemPackId: number): Observable<AreaItem[]> {
    return of(this._bookingInMemoryAreaItemGenerator.getAreaItems(areaItemPackId));
  }

  getAllAreaItems(): Observable<AreaItem[]> {
    return of(this._bookingInMemoryAreaItemGenerator.getAreaItems(1));
  }

  getAreaItemPacks(): Observable<AreaItemPack[]> {
    return of(this._bookingInMemoryAreaItemGenerator.areaItemPacks);
  }

  getAreaRestrictions(areaItemPackId: number, mergeAreaItemPackIds: number[]): Observable<TimeRestriction[]> {
    if (this._timeRestrictions.has(areaItemPackId)) {
      return of(this._timeRestrictions.get(areaItemPackId));
    }
    return of();
  }

  getBookingSlots(areaItemPackId: number, mergeAreaItemPackIds: number[], date: Date): Observable<BookingSlot[]> {
    let restriction: TimeRestriction;

    if (this._timeRestrictions.has(areaItemPackId)) {
      const dow: DayOfWeek = date.getDay();
      restriction = this._timeRestrictions.get(areaItemPackId).find(x => x.dayOfWeek === dow);
    }

    if (!restriction) {
      return of();
    }

    const slots = this._bookingSlotsGenerator.getOrGenerateSlots(
      areaItemPackId,
      restriction.fromTime,
      restriction.toTime,
      date);

    return of(slots);
  }

  getEventBookingSlots(areaItem: AreaItem, date: Date): Observable<BookingSlot[]> {

    if (!areaItem && !areaItem.areaIds) {
      return of();
    }

    const areaIds = areaItem.areaIds;
    const slots: BookingSlot[] = [];
    let startTime = 10.00;
    let endTime = 18.30;
    const offset = 0.5;

    areaIds.forEach((areaId, index) => {
      const parameters = this._eventBookingSlotParams.get(areaId);
      Array.prototype.push.apply(slots, this._eventBookingSlotsGenerator.getOrGenerateSlots(areaId, startTime, endTime, date, parameters));

      if (index > 0) {
        startTime += offset;
        endTime += offset;
      }
    });

    slots.sort((a, b) => a.fromTime - b.fromTime);
    return of(slots);
  }

  sendGroupEventOrder(groupEventOrder: GroupEventOrder): Observable<boolean> {
    return of(true);
  }

  sendContactForm(contactField: ContactField): Observable<boolean> {
    return of(true);
  }

  getEventAreaItemSlots(): Observable<EventAreaItemSlot[]> {
    return of(null);
  }

  getAvailableTicketQuantity(): Observable<number> {
    return of(-1);
  }
}
